/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAntennaBars1 = createReactComponent("antenna-bars-1", "IconAntennaBars1", [
  ["path", { d: "M6 18l0 .01", key: "svg-0" }],
  ["path", { d: "M10 18l0 .01", key: "svg-1" }],
  ["path", { d: "M14 18l0 .01", key: "svg-2" }],
  ["path", { d: "M18 18l0 .01", key: "svg-3" }]
]);

export { IconAntennaBars1 as default };
//# sourceMappingURL=IconAntennaBars1.js.map
